import {
  Backdrop,
  CircularProgress,
  makeStyles,
  Snackbar,
  Slide,
  Box,
  Typography,
} from "@material-ui/core";
// import { Alert, Slide, Snackbar } from "@mui/material";
import { useWeb3React } from "@web3-react/core";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// import { setLoading, setShowSnackbar } from "/redux/actions/web3Actions";
import Header from "../../Header";

import {
  getChainData,
  getDafiStaked,
  getGraphData,
  getRewards,
  getTopFiveUsers,
  getTotalDafiStaked,
  getTotalFeesDeposited,
  getTotalTestnetStakes,
  getTransactionsHistory,
  getOverallAPY,
  addProject,
} from "../../../redux";
import { PROTOKOL_CONTRACT_ADDRESS } from "../../../contract/constants";
import { initializeWeb3 } from "../../../contract/functions/functions";
import { isUser, setShowSnackbar } from "../../../redux/actions/web3Actions";

import { useDispatch, useSelector } from "react-redux";

const DRAWER_WIDTH = 250;

const useStyles = makeStyles((theme) => {
  return {
    page: {
      width: "100%",
    },
    root: {
      display: "flex",
    },
    snackContainer: {
      // background:
      //   "linear-gradient(139.63deg, rgba(96, 83, 132, 0.7) -23.88%, rgba(15, 8, 36, 0.7) 100%)",
      border: "1px solid rgba(230, 231, 233, 0.1)",
      borderRadius: 10,
      backgroundColor: "red",
      padding: "1rem 2rem",
      width: "30rem",
      height: "7rem",
      display: "flex",

      justifyContent: "center",
      alignItems: "center",
    },
    snackContainerText: {
      fontWeight: "600",
      fontSize: "1.4rem",
      lineHeight: "2rem",
      color: "#fff",
      textAlign: "center",
      [theme.breakpoints.up("xs")]: {
        marginLeft: "1rem",
      },
      [theme.breakpoints.down("xs")]: {
        marginTop: "1rem",
      },
    },
    drawer: {
      width: DRAWER_WIDTH,
      // background: "#0F0824",
      background: "transparent",
    },

    drawerPaper: {
      width: DRAWER_WIDTH,
      // background: "rgba(15, 8, 36, 1)",
      background: "transparent",
      opacity: 0.75,
      border: "1px solid rgba(230, 231, 233, 0.1)",
    },
    // toolbar: theme.mixins.toolbar,

    title: {
      padding: theme.spacing(2),
      color: "#fff",
    },

    listItemText: {
      color: "rgba(255,255,255,.7)",
      fontSize: 22,
      lineHeight: "27px",
    },

    listItemTextActive: {
      color: "rgba(255,255,255)",
      fontSize: 22,
      lineHeight: "27px",
    },

    active: {
      color: "#fff",
    },

    backdrop: {
      zIndex: theme.zIndex.drawer + 10,
      color: "#fff",
    },
  };
});

const Layout = ({ children }) => {
  const classes = useStyles();

  const web3Context = useWeb3React();
  const showSnackbar = useSelector((state) => state.ui.showSnackbar);
  const loading = useSelector((state) => state.ui.loading);

  console.log("starting loading....", loading);
  // const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (web3Context?.library?.currentProvider) {
      initializeWeb3(
        PROTOKOL_CONTRACT_ADDRESS,
        web3Context?.library?.currentProvider
      );
      dispatch({
        type: "SET_NETWORK",
      });
    }
  }, [web3Context]);

  useEffect(() => {
    // console.log("isuser web3Context?.account=> ", web3Context?.account);
    if (web3Context.account) {
      dispatch(isUser(web3Context?.account));
    }
  }, [web3Context?.account]);

  return (
    <div className={classes.root}>
      <Snackbar
        open={showSnackbar.open}
        autoHideDuration={3000}
        onClose={() => dispatch(setShowSnackbar({ open: false }))}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
        TransitionComponent={Slide}
      >
        <Box className={classes.snackContainer}>
          <Typography className={classes.snackContainerText}>
            {showSnackbar.message}
          </Typography>
        </Box>
      </Snackbar>
      <Backdrop open={loading} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={classes.page}>
        <Header />
        <div className={classes.toolbar} style={{ height: "100%" }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
